module.exports = __webpack_public_path__ + "img/HEART-O.eb05f994.svg";